import React, { Component, Context } from "react";
import clsx from "clsx";
import { NavLink } from "react-router-dom";
import HomeIcon from "@material-ui/icons/Home";
import HomeWorkIcon from "@material-ui/icons/HomeWork";
import BusinessIcon from "@material-ui/icons/Business";
// import InfiniteScroll from "react-infinite-scroller";
import LayoutContext, { ILayoutContext } from "../../../contexts/layout/LayoutContext";
import { IPSAgent, getAgentLink } from "../../../models/peer-support";
import { AgentActionsProps, AgentActions } from "./AgentActions";
import { PhoneLinkWeb } from "../../ui/PhoneLinkWeb";
import { EmailLinkWeb } from "../../ui/EmailLinkWeb";
import { UIAddress } from "../../google-maps/Address";
import { UINoData, UIStyledTooltip } from "../../ui/UIComponents";

type UIMembersProps = {
	agents: IPSAgent[];
	idToDelete?: string;
	renderList?: boolean;
	omitActions?: boolean;
	omitAddress?: boolean;
	noDataMsg?: string;
} & Omit<AgentActionsProps, "agent">;

export default class MembersList extends Component<UIMembersProps> {
	static contextType: Context<ILayoutContext> = LayoutContext;

	renderActions(agent: IPSAgent) {
		if (this.props.omitActions) return null;
		return (
			<AgentActions agent={agent} onDeleteAgent={this.props.onDeleteAgent} onEditAgent={this.props.onEditAgent} />
		);
	}

	renderZipCodes(agent: IPSAgent): React.ReactNode {
		// const zipCodes: string[] = [];
		// if (agent.homeAddress && agent.homeAddress.zip_code) {
		// 	zipCodes.push(agent.homeAddress.zip_code);
		// }
		// if (
		// 	agent.workAddress &&
		// 	agent.workAddress.zip_code &&
		// 	!zipCodes.find((z: string) => z === agent.workAddress.zip_code)
		// ) {
		// 	zipCodes.push(agent.workAddress.zip_code);
		// }
		// if (!zipCodes.length) return undefined;
		return (
			<>
				{agent.homeAddress && agent.homeAddress.zip_code && (
					<>
						{agent.workAddress &&
							agent.workAddress.zip_code &&
							agent.workAddress.zip_code === agent.homeAddress?.zip_code && (
								<UIStyledTooltip title="Home / Work">
									<HomeWorkIcon
										className="float-left mr-2 text-gray"
										style={{ fontSize: "12px", marginTop: "2px", marginLeft: "-1px" }}
									/>
								</UIStyledTooltip>
							)}
						{!agent.workAddress ||
							!agent.workAddress.zip_code ||
							(agent.workAddress?.zip_code !== agent.homeAddress?.zip_code && (
								<UIStyledTooltip title="Home">
									<HomeIcon
										className="float-left mr-2 text-gray"
										style={{ fontSize: "14px", marginTop: "2px", marginLeft: "-2px" }}
									/>
								</UIStyledTooltip>
							))}
						<UIAddress
							address={agent.homeAddress}
							// addressDisplay={agent.homeAddress.zip_code}
							showMapOnHover={true}
							omitPin={true}
							showZipOnly={agent.showHomeZipCodeOnly}
							// zoom={18}
						/>
					</>
				)}
				{agent.workAddress &&
					agent.workAddress.zip_code &&
					agent.workAddress.zip_code !== agent.homeAddress?.zip_code && (
						<>
							<UIStyledTooltip title="Work">
								<BusinessIcon
									className="float-left mr-2 text-gray"
									style={{ fontSize: "12px", marginTop: "2px", marginLeft: "0px" }}
								/>
							</UIStyledTooltip>
							<UIAddress
								address={agent.workAddress}
								// addressDisplay={agent.workAddress.zip_code}
								showMapOnHover={true}
								omitPin={true}
								showZipOnly={agent.showWorkZipCodeOnly}
								// zoom={18}
							/>
						</>
					)}
			</>
			// <div className="d-inline-flex align-items-center">
			// 	<LocationOnIcon
			// 		className="text-gray"
			// 		style={{ fontSize: "12px", marginTop: "-1px", marginRight: "2px" }}
			// 	/>
			// 	{zipCodes.join(", ")}
			// </div>
		);
	}

	renderList() {
		return this.props.agents.map((agent: IPSAgent, i: number) => {
			return (
				<div
					key={agent.id}
					className={clsx(
						"item-mobile-row alternate-row-style text-sm",
						i === 0 && "first-row",
						agent.id === this.props.idToDelete && "animated fadeOutUp z-index-minus-1"
					)}
				>
					<div className="d-flex flex-row justify-content-between">
						<h2 className="title-link mb-2" style={{ fontSize: "1rem" }}>
							<NavLink to={getAgentLink(agent)}>
								{agent.first_name} {agent.last_name}
							</NavLink>
						</h2>
						<div style={{ marginTop: "-5px", paddingLeft: "10px" }}>{this.renderActions(agent)}</div>
					</div>
					<PhoneLinkWeb className="mb-1" number={agent.mobile_number} />
					<div className="">
						<EmailLinkWeb className="mb-1" email={agent.email} />
					</div>
					{!this.props.omitAddress && (
						<div className="agents-list-agent-zip-codes">{this.renderZipCodes(agent)}</div>
					)}
				</div>
			);
		});
	}

	render() {
		if (!this.props.agents || !this.props.agents.length)
			return <UINoData msg={this.props.noDataMsg || "No agents"} />;
		return (
			<div className="agents-list">
				{(this.props.renderList || !this.context.settings.isDesktopRes) && this.renderList()}
				{!this.props.renderList && this.context.settings.isDesktopRes && (
					<table className="table alternate-table text-sm">
						<thead>
							<tr>
								<th scope="col">Member Name</th>
								<th scope="col" colSpan={2}>
									Email
								</th>
								<th scope="col">Phone Number</th>
								<th scope="col" colSpan={2}>
									Zip Code
								</th>
								{/* <th>Team sheri</th> */}
								<th scope="col">Actions</th>
							</tr>
						</thead>
						<tbody className="animated1 fadeInDown faster">
							{/* <InfiniteScroll
								pageStart={0}
								// loadMore={loadFunc}
								hasMore={true || false}
								loader={
									<div className="loader" key={0}>
										Loading ...
									</div>
								}
							> */}
							{this.props.agents.map((agent: IPSAgent, i: number) => {
								return (
									<tr
										key={agent.id}
										className={clsx(
											agent.id === this.props.idToDelete && "animated fadeOutUp z-index-minus-1"
										)}
									>
										<td className="title-link">
											<NavLink to={getAgentLink(agent)}>
												{agent.first_name} {agent.last_name}
											</NavLink>
										</td>
										<td className="gray-link inner-link pr-1" colSpan={2}>
											<EmailLinkWeb email={agent.email} />
										</td>
										<td>
											<PhoneLinkWeb number={agent.mobile_number} />
										</td>
										<td colSpan={2}> {!this.props.omitAddress && this.renderZipCodes(agent)}</td>
										{/* <td>{agent.peerTeam} sheri</td> */}
										<td className="actions-cell">{this.renderActions(agent)}</td>
									</tr>
								);
							})}
							{/* </InfiniteScroll> */}
						</tbody>
					</table>
				)}
			</div>
		);
	}
}
